export class AbstractClient {
  protected _fetch(params: {
    url: string;
    method: string;
    params?: Record<string, any>;
    headers?: Record<string, any>;
    bodyMime?:
      | "application/json"
      | "multipart/form-data"
      | "application/x-www-form-urlencoded";
    body?: Record<string, any> | FormData;
    auth?: string[];
  }): Promise<Response> {
    throw new Error("Method not implemented.");
  }
}

export class CompositionClient extends AbstractClient {
  protected _client: AbstractClient;
  constructor(client: AbstractClient) {
    super();
    this._client = client;
  }
  protected _fetch(params: {
    url: string;
    method: string;
    params?: Record<string, any>;
    headers?: Record<string, any>;
    bodyMime?:
      | "application/json"
      | "multipart/form-data"
      | "application/x-www-form-urlencoded";
    body?: Record<string, any> | FormData;
    auth?: string[];
  }): Promise<Response> {
    // @ts-ignore
    return this._client._fetch(params);
  }
}

export class APIError extends Error {
  status: number;
  info: string;
  constructor(status: number, info: string) {
    super(`API Error ${status}: ${info}`);
    this.status = status;
    this.info = info;
  }
}
